import InfoCaption from "ds_legacy/components/InfoCaption";
import { APP_BACKGROUND, ICON_GREY } from "ds_legacy/materials/colors";
import { HorizontalLayout } from "ds_legacy/materials/layouts";
import {
  dp,
  margin,
  RESPONSIVE_BREAKPOINT_MOBILE,
  RESPONSIVE_BREAKPOINT_TABLET,
  sizing,
} from "ds_legacy/materials/metrics";
import {
  Caption,
  Display,
  FONT_SIZE_15,
  FONT_SIZE_20,
  Subheading,
  Title,
} from "ds_legacy/materials/typography";
import { useMedia } from "dsl/atoms/ResponsiveMedia";
import React from "react";
import styled from "styled-components";

export const iconStyle = {
  color: ICON_GREY,
  fontSize: FONT_SIZE_20,
  marginTop: sizing(2),
};
export const OnboardingWrapper = styled.div`
  display: flex;
  height: 100vh;
  width: 100vw;
  background-color: ${APP_BACKGROUND};
  position: relative;
  @media screen and (max-width: ${dp(RESPONSIVE_BREAKPOINT_TABLET - 1)}) {
    & {
      flex-direction: column;
    }
  }
`;

export const OnboardingPageWrapper = styled.div`
  display: flex;
  flex: 1;
  min-width: 0;
  justify-content: flex-start;
  align-items: flex-start;
  height: 100%;
  overflow: auto;
  padding: ${margin(2, 2)};
  box-sizing: border-box;

  @media screen and (max-width: ${dp(RESPONSIVE_BREAKPOINT_TABLET - 1)}) {
    & {
      width: 100%;
      height: auto;
      flex: 1;
      padding: ${margin(1, 1)};
    }
  }
`;

export const PageTitle = ({
  isTablet,
  title,
}: {
  isTablet: boolean;
  title: string;
}) => {
  if (isTablet)
    return (
      <Title dark data-testid="page-title" margin={margin(0)} primary>
        {title}
      </Title>
    );

  return (
    <Display
      dark
      data-testid="page-title"
      primary
      style={{
        display: "flex",
        justifyContent: "flex-start",
        margin: margin(6, 2),
        whiteSpace: "nowrap",
      }}
    >
      {title}
    </Display>
  );
};

const Header = styled(Subheading)`
  margin: ${margin(2, 0)};
  font-size: ${FONT_SIZE_20};
  @media screen and (max-width: ${dp(RESPONSIVE_BREAKPOINT_MOBILE - 1)}) {
    & {
      font-size: ${FONT_SIZE_15};
      margin: ${margin(1, 0, 1, 0)};
    }
  }
`;

export const CardTitle = ({
  currentStep,
  title,
}: {
  currentStep?: string;
  title: string;
}) => {
  const { isTablet } = useMedia();
  if (isTablet)
    return (
      <HorizontalLayout>
        <Header bold data-testid="onboarding-title">
          {title}
        </Header>
        {currentStep && (
          <Caption margin={margin(2, 0, 0, 1)}>{currentStep}</Caption>
        )}
      </HorizontalLayout>
    );

  return (
    <Header bold data-testid="onboarding-title">
      {title}
    </Header>
  );
};

export const PageWrapperWithInfo = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  gap: ${sizing(3)};
  width: 100%;
  max-width: ${sizing(120)};
  margin: ${margin(2, 0)};
  padding: ${margin(0, 1)};
  box-sizing: border-box;

  @media screen and (max-width: ${dp(RESPONSIVE_BREAKPOINT_TABLET - 1)}) {
    & {
      margin: ${margin(0)};
      flex-direction: column;
      align-items: flex-start;
    }
  }
`;

export const SingleButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  margin: margin(2, 0);
`;

export const ButtonTextWrapper = styled.span`
  width: 100%;
`;

export const HintWrapper = styled.div`
  flex: 0 1 ${sizing(42)};
  min-width: ${sizing(28)};
  max-width: ${sizing(47)};
  align-self: flex-start;

  @media screen and (max-width: ${dp(RESPONSIVE_BREAKPOINT_TABLET - 1)}) {
    & {
      width: 100%;
      max-width: 100%;
    }
  }
`;

export const OnboardingFormActions = styled.div<{
  $align?: "between" | "end";
}>`
  display: flex;
  justify-content: ${({ $align = "between" }) =>
    $align === "end" ? "flex-end" : "space-between"};
  align-items: center;
  width: 100%;
  max-width: ${sizing(52)};
  margin: ${margin(1.5, 0)};

  @media screen and (max-width: ${dp(RESPONSIVE_BREAKPOINT_TABLET - 1)}) {
    & {
      max-width: 90vw;
      align-self: flex-start;
    }
  }
`;

export function HintContainer({ children }: { children: React.ReactNode }) {
  const { isTablet } = useMedia();
  return (
    <HorizontalLayout
      style={{
        margin: isTablet ? margin(0, 0.5) : margin(2, 0),
        maxWidth: sizing(42),
      }}
    >
      <InfoCaption>{children}</InfoCaption>
    </HorizontalLayout>
  );
}
